<template>
  <block-action
    :key="key"
    class="d-flex w-100"
    :block-action="blockAction"
    @purchaseChecked="handlePurchaseChecked"
  >
    <v-button primary>{{ displayText }}</v-button>
  </block-action>
</template>

<script>
import { mapGetters } from "vuex"

import EventBus, { EVENTS } from "@/lib/event-bus"

import BlockAction from "@/components/BlockAction"

export default {
  components: {
    BlockAction
  },

  props: {
    text: { type: String, required: true },
    postPurchaseText: { type: String, default: "Continue" },
    blockAction: { type: Object, default: () => ({}) }
  },

  data() {
    return {
      displayText: this.text,
      key: 0
    }
  },

  computed: {
    ...mapGetters("auth", ["isAuthenticated", "hasCheckedAuthentication"])
  },

  mounted() {
    EventBus.$on(EVENTS.CHECKOUT_COMPLETED, this.handleCheckoutCompleted)
  },

  beforeDestroy() {
    EventBus.$off(EVENTS.CHECKOUT_COMPLETED, this.handleCheckoutCompleted)
  },

  methods: {
    handleCheckoutCompleted() {
      this.key++
    },

    handlePurchaseChecked(hasPurchased) {
      this.displayText = hasPurchased
        ? this.postPurchaseText || this.text
        : this.text
    }
  },

  watch: {
    text(text) {
      this.displayText = text
    },

    hasCheckedAuthentication: {
      immediate: true,
      handler() {
        this.key++
      }
    },

    isAuthenticated: {
      immediate: true,
      handler() {
        this.key++
      }
    }
  }
}
</script>
